import React from 'react';
import i18next from 'i18next';
import * as S from '../styles';

export default function tableStructure(
  refereeAssistants,
  selectedAssistant,
  setSelectedAssistant
) {
  let processedColumns = [];

  if (Object.keys(refereeAssistants).length > 0) {
    processedColumns = refereeAssistants.referees.map((arbiter, index) => {
      return {
        Header: (
          <S.AvatarHeader
            isSelected={selectedAssistant === index}
            onClick={() => setSelectedAssistant(index)}
          >
            <S.RefereeRole>{i18next.t(arbiter.role)}</S.RefereeRole>
            <S.AvatarPhoto src={arbiter.photoUrl} />
            <S.RefereeName>{arbiter.refereeNickname}</S.RefereeName>
          </S.AvatarHeader>
        ),
        accessor: `referee${arbiter.referee}`,
        Footer:
          refereeAssistants.arbitratedMatchesTable.totals[
            `totalReferee${arbiter.referee}`
          ],
      };
    });
  }

  return [
    {
      Header: <S.SeasonHeader>{i18next.t('season')}</S.SeasonHeader>,
      accessor: 'season',
      Footer: <S.Total>{i18next.t('total')}</S.Total>,
    },
    ...processedColumns,
  ];
}
